import React from 'react';
import { Box, Typography, Button, useTheme, Grid2 } from '@mui/material';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Carousel from './Carousel';
import CarouselImage from './CarouselImage';


const slides = [
    {
        title: 'Mobile App 01',
        subtitle: 'Banner',
        background: '/assets/home/carousel/mperito_mobileapp_01a.png',
    },
    {
        title: '',
        subtitle: '',
        background: '/assets/home/carousel/mperito_mobileapp_02.png',
    },
    {
        title: '',
        subtitle: '',
        background: '/assets/home/carousel/mperito_mobileapp_03.png',
    },
    {
        title: '',
        subtitle: '',
        background: '/assets/home/carousel/mperito_mobileapp_03.png',
    },
    {
        title: '',
        subtitle: '',
        background: '/assets/home/carousel/mperito_mobileapp_04.png',
    },
    {
        title: '',
        subtitle: '',
        background: '/assets/home/carousel/mperito_mobileapp_05.png',
    },
    {
        title: '',
        subtitle: '',
        background: '/assets/home/carousel/mperito_mobileapp_09.png',
    }
];

const SlideOne = ({
    title,
    subtitle,
    button1Label,
    button1Action,
    button2Label,
    button2Action
}) => {
    const theme = useTheme();

    return (
        <Grid2 container sx={{
            backgroundColor: theme.palette.primary.main,
        }}>
            <Grid2 size={{ xs: 12, md: 6 }} sx={{ order: { xs: 2, md: 1 } }}>
                <Box
                    sx={{
                        backgroundColor: theme.palette.primary.main,
                        height: {
                            xs: '50vh',
                            md: '90vh',
                        },
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        padding: '10% 20% 0', // Top padding is 15%, left and right are 10%
                        color: theme.palette.primary.contrastText,
                    }}
                >
                    {/* Title and Subtitle */}
                    <Box >
                        <Typography
                            variant="h2"
                            sx={{
                                mb: '5%',
                                lineHeight: 1.2,
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'pre-wrap',
                                fontWeight: 700,
                            }}
                        >
                            {title}
                        </Typography>

                        <Typography variant="h5">
                            {subtitle}
                        </Typography>
                    </Box>

                    {/* Buttons */}
                    <Box sx={{ display: 'flex', gap: 2, mb: '15%' }}>
                        <Button variant="contained" color="secondary" size="large"
                            sx={{
                                padding: { xs: '8px 16px', md: '16px 32px'},
                                fontSize: { xs: '1rem', md:'1.2rem'},
                                borderRadius: { xs:'20px', md:'40px'},
                                boxShadow: 4,
                            }} onClick={button1Action}>
                            {button1Label}
                        </Button>
                        <Button variant="outlined" color="secondary" size="large"
                            sx={{
                                padding: { xs: '8px 16px', md: '16px 32px'},
                                fontSize: { xs: '1rem', md:'1.2rem'},
                                borderRadius: { xs:'20px', md:'40px'},
                                boxShadow: 4,
                            }} onClick={button2Action}>
                            {button2Label}
                        </Button>
                    </Box>
                </Box>
            </Grid2>
            <Grid2 maxWidth size={{ xs: 12, md: 6 }} alignItems={'center'} sx={{ order: { xs: 1, md: 2 } }}>
                <Box display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        width: '50%', height: {
                            xs: '40vh', // Only image in main container for mobile
                            md: '90vh', // Full height on desktop
                        }, maxWidth: '400', mx: 'auto'
                    }}>
                    <CarouselImage slides={slides} />
                </Box>

            </Grid2>

        </Grid2>
    );
};

export default SlideOne;
